import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router';
import PropTypes from 'prop-types';

import FilterMarket from '../components/analyticDashboard/markets/FilterMarket/FilterMarket';
import { selectActiveMarket, selectAvailableMarkets } from '../slices/markets/selectors/selectBasicMarketData';
import { setActiveMarket } from '../slices/markets/marketReducers';
import { setQualityPackerPlant, setQualityGrinder } from '../slices/quality/qualityReducers';
import { updateShowOutlook } from '../slices/treasury-details/treasuryDetailsReducers';
import { updateActivePackerPlant, updateActiveGrinder } from '../slices/markets-details/supplyChainDetails';
import { ChevronRight } from './Icons';
import { ALL_PACKER_PLANTS_OPTION, ALL_GRINDERS_OPTION, DEFAULT_GRINDER_OPTION } from '../slices/quality/qualityConfig';
import { setQualityNCRsActivePackerPlants } from '../slices/quality-details-ncrs/qualityDetailsNcrsReducers';
import { MARKETS } from '../config/markets';
import withRouter from '@/components/utilities/withRouter';
import { Text, Grid, GridItem } from '@chakra-ui/react';

const TabBar = ({ setActiveMarketAction = setActiveMarket }) => {
  const dispatch = useDispatch();
  const { market } = useParams();
  const { pathname } = useLocation();

  const activeMarket = useSelector(selectActiveMarket);
  const activeMarketKey = activeMarket.key;
  const availableMarkets = useSelector(selectAvailableMarkets);

  const handleActiveMarketChange = React.useCallback(
    newVal => {
      dispatch(setActiveMarketAction(newVal));
      dispatch(setQualityPackerPlant(ALL_PACKER_PLANTS_OPTION));
      dispatch(setQualityGrinder(ALL_GRINDERS_OPTION));
      dispatch(setQualityNCRsActivePackerPlants([undefined]));
    },
    [dispatch, setActiveMarketAction, setQualityPackerPlant]
  );

  const handleQualityActiveMarketChange = React.useCallback(
    newVal => {
      dispatch(setActiveMarketAction(newVal));
      dispatch(setQualityPackerPlant(ALL_PACKER_PLANTS_OPTION));
      dispatch(setQualityGrinder(DEFAULT_GRINDER_OPTION));
      dispatch(setQualityNCRsActivePackerPlants([undefined]));
    },
    [dispatch, setActiveMarketAction, setQualityPackerPlant]
  );

  const handleBackToTreasury = React.useCallback(() => {
    dispatch(updateShowOutlook(true));
  }, [dispatch]);

  const handleBackToQuality = React.useCallback(() => {
    dispatch(setActiveMarketAction(MARKETS.Australia.key));
    dispatch(setQualityPackerPlant(ALL_PACKER_PLANTS_OPTION));
    dispatch(setQualityGrinder(DEFAULT_GRINDER_OPTION));
  }, [dispatch]);

  const handleBackToMarkets = React.useCallback(() => {
    dispatch(updateActivePackerPlant(null));
    dispatch(updateActiveGrinder(null));
  }, [dispatch]);

  const isDetailsPage = pathname.indexOf('details') !== -1;
  const isTreasuryDetails = pathname.indexOf('treasury') !== -1;
  const isQualityDetails = pathname.indexOf('quality') !== -1;

  let handlerActiveMarketChange = handleActiveMarketChange;
  let urlParam = 'market';
  let clickHandler = handleBackToMarkets;
  if (isTreasuryDetails) {
    urlParam = 'treasury';
    clickHandler = handleBackToTreasury;
  } else if (isQualityDetails) {
    urlParam = 'quality';
    clickHandler = handleBackToQuality;
    handlerActiveMarketChange = handleQualityActiveMarketChange;
  }
  return (
    <Grid templateColumns="repeat(24, 1fr)" style={{ backgroundColor: 'white' }} align="middle" justify="space-between">
      {!isDetailsPage ? (
        <>
          <GridItem colSpan={16} />
          <GridItem colSpan={8} style={{ marginBottom: 20, textAlign: 'end', paddingRight: '20px' }}>
            <FilterMarket
              markets={availableMarkets}
              activeMarket={activeMarketKey}
              onActiveMarketChange={handlerActiveMarketChange}
            />
          </GridItem>
        </>
      ) : (
        <GridItem colSpan={16} style={{ height: 64, paddingTop: 20 }}>
          <Link to={`/analytic-dashboard/${urlParam}/${market}`} onClick={clickHandler}>
            <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 20 }}>
              <div
                style={{
                  display: 'inline-block',
                  width: '18px',
                  height: '18px',
                  transform: 'rotate(180deg)',
                }}
              >
                <ChevronRight />
              </div>
              <Text style={{ color: '#FC5D36' }}>
                Back to <strong>{urlParam}</strong>
              </Text>
            </div>
          </Link>
        </GridItem>
      )}
    </Grid>
  );
};

TabBar.propTypes = {
  setActiveMarketAction: PropTypes.func,
};

export default withRouter(TabBar);
